import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5221a492"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "page-toolbar-actions__icon",
  "aria-hidden": "true"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Thao tác", -1))
const _hoisted_3 = {
  class: "page-toolbar-actions__dropdown",
  role: "menu",
  "aria-label": "Thao tác"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "page-toolbar-actions-slot",
  class: "page-toolbar-actions__dropdown-body"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { onBeforeUnmount, onMounted, ref } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faChevronDown,
  faEllipsisVertical,
} from "@fortawesome/free-solid-svg-icons";
import { usePageToolbar } from "@/core/hooks/usePageToolbar";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageToolbarActionsDropdown',
  setup(__props) {

const { pageToolbar, actionsOpen, filtersOpen, approvalOpen } =
  usePageToolbar();
const rootRef = ref<HTMLElement | null>(null);

function toggleActions() {
  const next = !actionsOpen.value;
  actionsOpen.value = next;
  if (next) {
    filtersOpen.value = false;
    approvalOpen.value = false;
  }
}

function onDocumentClick(event: MouseEvent) {
  if (!actionsOpen.value || !rootRef.value) {
    return;
  }
  const target = event.target as Node | null;
  if (target && !rootRef.value.contains(target)) {
    actionsOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener("click", onDocumentClick, true);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", onDocumentClick, true);
});

return (_ctx: any,_cache: any) => {
  return (_unref(pageToolbar).showActions)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "page-toolbar-actions",
        ref_key: "rootRef",
        ref: rootRef
      }, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["page-toolbar-actions__btn", { 'page-toolbar-actions__btn--open': _unref(actionsOpen) }]),
          onClick: toggleActions
        }, [
          _createElementVNode("span", _hoisted_1, [
            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faEllipsisVertical) }, null, 8, ["icon"])
          ]),
          _hoisted_2,
          _createVNode(_unref(FontAwesomeIcon), {
            icon: _unref(faChevronDown),
            class: _normalizeClass(["page-toolbar-actions__chevron", { 'page-toolbar-actions__chevron--open': _unref(actionsOpen) }])
          }, null, 8, ["icon", "class"])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_3, _hoisted_5, 512), [
          [_vShow, _unref(actionsOpen)]
        ])
      ], 512))
    : _createCommentVNode("", true)
}
}

})